var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrailerLog(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon / trailer (no photo)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Live-DAC",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Private-car-Tailgating-Copy-3",
    transform: "translate(-1349.000000, -716.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Past-entries",
    transform: "translate(80.000000, 603.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trailer",
    transform: "translate(1263.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-/-trailer-(no-photo)",
    transform: "translate(6.000000, 91.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#979797",
    fill: "#D8D8D8",
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "graph/trailer_black",
    transform: "translate(3.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "graph/trailer_grey"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.9053763,7.74651822 C19.5428925,7.00036354 18.7777483,6.48602151 17.8924731,6.48602151 C16.8980223,6.48602151 16.0551595,7.13504745 15.7643629,8.03262132 L7.54283832,8.03262132 C7.37885251,7.17587763 6.9077667,6.80769365 5.83216167,6.71921032 C5.35329028,6.71921032 3.40923639,6.71921032 1.2997369e-17,6.71921032 L0,0 L25.944086,0 L25.944086,8.03262132 C25.0896124,8.03262132 24.4708785,8.03262132 24.0878844,8.03262132 L24.0463897,8.03262132 C23.7555932,7.13504745 22.9127304,6.48602151 21.9182796,6.48602151 C21.0330043,6.48602151 20.2678601,7.00036354 19.9053763,7.74651822 Z",
    id: "Combined-Shape",
    fillOpacity: 0.87,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    strokeOpacity: 0.87,
    stroke: "#000000",
    strokeWidth: 2.6,
    cx: 17.8924731,
    cy: 8.72258065,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-5",
    strokeOpacity: 0.87,
    stroke: "#000000",
    strokeWidth: 2.6,
    cx: 21.9182796,
    cy: 8.72258065,
    r: 1
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrailerLog);
export default __webpack_public_path__ + "static/media/trailer_log.6797e8b3d9821db0a1ec152eff1250fe.svg";
export { ForwardRef as ReactComponent };